import queryString from 'query-string';
import React, { useEffect, useState } from 'react';

import { RandomGradProgramsBlockData } from 'api/cms';
import { FilestackImageData, RandomGradProgram } from 'api/types/shared.types';
import { TileCarousel } from 'components/TileCarousel';
import { shuffleArray } from 'utils/functional';
import { getJson } from 'utils/http';
import { listingSearchHomePath } from 'utils/searchHomePages';

const getGradPrograms = (areasOfStudy: string[] | null | undefined) => {
  const args = queryString.stringify({
    area: areasOfStudy || [],
  });
  const url = `/data/website/random-grad-programs?${args}`;
  return getJson(url).then(
    ({ gradPrograms }: { gradPrograms: Array<RandomGradProgram> }) =>
      gradPrograms.map((gradProgram) => ({
        city: gradProgram.addressCity,
        id: gradProgram.id,
        logo: gradProgram.logo,
        orgName: gradProgram.schoolName,
        name: gradProgram.name,
        state: gradProgram.addressStateCode,
        url: gradProgram.url,
      }))
  );
};

type Props = {
  data: RandomGradProgramsBlockData;
};

export function RandomGradProgramsBlock({
  data: { areasOfStudy, headline },
}: Props) {
  const [gradPrograms, setGradPrograms] = useState([]);
  useEffect(() => {
    getGradPrograms(areasOfStudy).then(
      (
        programs: Array<{
          city?: string;
          id?: string;
          logo?: FilestackImageData;
          objectID?: string;
          orgName?: string;
          name?: string;
          state?: string;
          url?:
            | string
            | {
                en: string;
                es: string;
                pt: string;
              };
        }>
      ) => {
        setGradPrograms(shuffleArray(programs));
      }
    );
  }, [areasOfStudy]);
  return (
    <TileCarousel
      headline={headline}
      results={gradPrograms}
      seeAllText={
        /* TRANSLATORS: Link to grad program search */
        getText('See all Grad Programs')
      }
      seeAllUrl={`${listingSearchHomePath('GRAD_PROGRAM')}?q=`}
      listingType="GRAD_PROGRAM"
    />
  );
}
